@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-raised" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{ 'notificationDetail.saveButton' | t }}</span>
        </button>
        @if (id > 0) {
            <button class="btn btn-raised red" (click)="deleteClick()">
                <i class="fas fa-trash"></i>
                <span>{{ 'notificationDetail.deleteButton' | t }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card" [formGroup]="form">
        <div class="detail-page-card-title">{{ 'notificationDetail.editNotificationTitle' | t }}</div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'notificationDetail.nameLabel' | t"
                    dataUiid="notification-detail-name"
                    formControlName="name"
                    name="notification-name"
                    [required]="true"
                    [placeholder]="'notificationDetail.requiredPlaceholder' | t"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    data-uiid="notification-detail-active"
                    [label]="'notificationDetail.activeLabel' | t"
                    formControlName="active"
                ></cerrix-checkbox>
            </div>
            @if (!isTaskModule) {
                <div class="form-group">
                    <label>{{ 'notificationDetail.periodLabel' | t }}</label>
                    <ng-select
                        id="periodSelect"
                        name="periodSelect"
                        data-uiid="notification-detail-period"
                        [items]="periods"
                        bindLabel="Name"
                        bindValue="ID"
                        [multiple]="false"
                        formControlName="period"
                        [placeholder]="'notificationDetail.requiredPlaceholder' | t"
                    ></ng-select>
                </div>
            }
            @if (enableTypeField) {
                <div class="form-group">
                    <label>{{ 'notificationDetail.typeLabel' | t }}</label>
                    <ng-select
                        id="typeSelect"
                        name="typeSelect"
                        data-uiid="notification-detail-type"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [items]="types"
                        bindLabel="Name"
                        bindValue="ID"
                        formControlName="types"
                        [placeholder]="'notificationDetail.requiredPlaceholder' | t"
                    ></ng-select>
                </div>
            }
            @if (!isTaskModule) {
                <div class="form-group">
                    <label>{{ 'notificationDetail.subTypeLabel' | t }}</label>
                    <ng-select
                        id="subTypeSelect"
                        name="subTypeSelect"
                        data-uiid="notification-detail-subtype"
                        [items]="subTypes"
                        bindLabel="Name"
                        bindValue="ID"
                        [multiple]="false"
                        formControlName="subType"
                        [placeholder]="'notificationDetail.requiredPlaceholder' | t"
                        (change)="reloadRecipients($event)"
                    >
                    </ng-select>
                </div>
            }
            <div class="form-group">
                <label>
                    {{ 'notificationDetail.recipientsLabel' | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'notificationDetail.recipientsTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="recipientSelect"
                    name="recipientSelect"
                    data-uiid="notification-detail-recipients"
                    [items]="recipients"
                    bindLabel="DisplayName"
                    [closeOnSelect]="false"
                    bindValue="ID"
                    [multiple]="true"
                    formControlName="recipients"
                    [placeholder]="'notificationDetail.recipientsPlaceholder' | t"
                ></ng-select>
            </div>

            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'notificationDetail.messageLabel' | t"
                    dataUiid="notification-detail-subject"
                    formControlName="subject"
                    name="notification-subject"
                    [required]="true"
                    [placeholder]="'notificationDetail.requiredPlaceholder' | t"
                    (click)="setFocusToSubject()"
                ></cerrix-textfield>
                @for (keyword of keywords; track keyword) {
                    <button class="keyword-button" (click)="addKeyword(keyword)">
                        {{ keyword }}
                    </button>
                }
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="notification.message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChange($event)"
                    (click)="deFocusSubject()"
                    #editor
                ></cerrix-editor>
            </div>

            <div class="form-group">
                <label>{{ 'notificationDetail.selectedOrganizationsLabel' | t }}</label>
                <i
                    class="fas fa-info-circle ms-2"
                    [matTooltip]="noOrganizationsSelectedDescription"
                    position="right"
                ></i>
                <cerrix-select-tree
                    class="fullWidth"
                    [getDataMethod]="organizationRequest"
                    formControlName="organizations"
                    [multiselect]="true"
                >
                </cerrix-select-tree>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
